import { get, del, post, put } from '../../../../GlobalModules/Utility/Http'
import {
  getGrns,
  deleteGrn,
  createGrn,
  updateGrn,
  makeCompleted
} from '../Model/GrnModel'

export const getGrnsApi = async (filters = {}) => {
  try {
    let queryParams = {}

    const filtersObj = {
      limit: filters.limit || 10,
      offset: filters.offset || 0,
      store_id: localStorage.getItem('store_id')
    }

    if (filters.sort && filters.sort.length > 0) {
      filtersObj.sort = filters.sort.map((item) => ({
        colId: item.colId,
        sort: item.sort || 'asc'
      }))
    } else {
      filtersObj.sort = [
        {
          colId: 'id',
          sort: 'desc'
        }
      ]
    }

    if (filters.search && filters.search !== '') {
      queryParams.filter_op = JSON.stringify({ search_attr: 'substring' })
      filtersObj.search_attr = filters.search
    }

    if (filters.from_created_date) {
      filtersObj.from_created_date = filters.from_created_date
    }
    if (filters.to_created_date) {
      filtersObj.to_created_date = filters.to_created_date
    }

    queryParams.filters = JSON.stringify(filtersObj)

    const response = await get(
      `${process.env.EXTENDED_URL}procurement/grns`,
      queryParams
    )
    return getGrns(response)
  } catch (error) {
    throw error
  }
}

export const deleteGrnApi = async (slack) => {
  const response = await del(`${process.env.EXTENDED_URL}procurement/grns/${slack}`)
  return deleteGrn(response)
}

export const createGrnApi = async (data) => {
  const response = await post(`${process.env.EXTENDED_URL}procurement/grns/from-po/`, data)
  return createGrn(response)
}

export const createGrnFromPoApi = async (poSlack, data) => {
  const response = await post(`${process.env.EXTENDED_URL}procurement/grns/from-po/${poSlack}`, data)
  return createGrn(response)
}

export const updateGrnApi = async (slack, data) => {
  const response = await put(
    `${process.env.EXTENDED_URL}procurement/grns/${slack}`,
    data
  )
  return updateGrn(response)
}

export const getGrnApi = async (slack) => {
  const response = await get(`${process.env.EXTENDED_URL}procurement/grns/${slack}`)
  return response?.data || { success: false, data: null }
}

export const exportGrnsApi = async (data = {}) => {
  try {
    const requestBody = {
      from_created_date:
        data.from_created_date ||
        new Date(Date.now() - 365 * 24 * 60 * 60 * 1000)
          .toISOString()
          .split('T')[0],
      to_created_date:
        data.to_created_date || new Date().toISOString().split('T')[0]
    }
    if (data.status != null && data.status !== '') {
      requestBody.status = data.status
    }
    requestBody.store_id = localStorage.getItem('store_id')

    const response = await post(
      `${process.env.EXTENDED_URL}report/grn`,
      requestBody
    )

    if (response?.data?.success && response?.data?.link) {
      if (String(response.data.link).startsWith('data:')) {
        const base64Data = response.data.link.split(',')[1]
        const binaryData = atob(base64Data)
        const bytes = new Uint8Array(binaryData.length)
        for (let i = 0; i < binaryData.length; i++)
          bytes[i] = binaryData.charCodeAt(i)
        return {
          success: true,
          data: bytes.buffer,
          message: 'Export completed - converted from base64',
          filename: response.data.filename || 'grn_export.xlsx'
        }
      }
      return {
        success: true,
        data: response.data.link,
        message: 'Export completed - file URL provided',
        isFileUrl: true,
        filename: response.data.filename || 'grn_export.xlsx'
      }
    }

    return {
      success: true,
      data: response.data,
      message: 'Export completed'
    }
  } catch (error) {
    console.error('Error exporting GRNs:', error)
    throw error
  }
}

export const updateGrnStatusApi = async (slack, status) => {
  try {
    const response = await put(
      `${process.env.EXTENDED_URL}grn/status/${slack}`,
      { status }
    )
    return (
      response?.data || { success: false, message: 'Failed to update status' }
    )
  } catch (error) {
    return (
      error?.response?.data || {
        success: false,
        message: 'Failed to update status'
      }
    )
  }
}

export const loadProductsForGrnApi = async (keywords, billToSlack) => {
  const trimmed = String(keywords || '').trim()

  const body = {
    keywords: trimmed || ' ',
    supplier: billToSlack,
    store_id: localStorage.getItem('store_id')
  }
  const response = await post(
    `${process.env.EXTENDED_URL}common/load_product_for_po`,
    body
  )
  const data =
    response?.data?.data || (Array.isArray(response?.data) ? response.data : [])
  return Array.isArray(data) ? data : []
}

export const searchPurchaseOrdersForGrnApi = async (filters = {}) => {
  try {
    let queryParams = {}

    const filtersObj = {
      // limit: filters.limit || 20,
      // offset: filters.offset || 0,
      store_id: localStorage.getItem('store_id'),
      status: [3,5]
    }

    // Sort mapping - using field instead of colId for consistency with PO controller
    if (filters.sort && filters.sort.length > 0) {
      filtersObj.sort = filters.sort.map((item) => ({
        field: item.field,
        sort: item.sort || 'desc'
      }))
    } else {
      filtersObj.sort = [
        {
          field: 'id',
          sort: 'desc'
        }
      ]
    }

    // Optional search - only then send filter_op
    if (filters.search && filters.search !== '') {
      queryParams.filter_op = JSON.stringify({ search_attr: 'substring' })
      filtersObj.search_attr = filters.search
    }

    // Optional date range
    if (filters.from_created_date) {
      filtersObj.from_created_date = filters.from_created_date
    }
    if (filters.to_created_date) {
      filtersObj.to_created_date = filters.to_created_date
    }

    queryParams.filters = JSON.stringify(filtersObj)

    const response = await get(
      `${process.env.EXTENDED_URL}purchase_order`,
      queryParams
    )
    
    // Return the response data directly for GRN form usage
    return {
      success: response?.data?.success || false,
      data: response?.data?.data || [],
      message: response?.data?.message || 'Purchase orders retrieved successfully',
      total: response?.data?.total || 0
    }
  } catch (error) {
    console.error('Error searching purchase orders for GRN:', error)
    return {
      success: false,
      data: [],
      message: 'Failed to search purchase orders',
      total: 0
    }
  }
}

export const makeCompletedApi = async (slack) => {
  const response = await put(`${process.env.EXTENDED_URL}procurement/grns/${slack}/complete`)
  return makeCompleted(response)
}

export const getGrnInvoiceDataApi = async (slack) => {
  try {
    const response = await get(`${process.env.EXTENDED_URL}procurement/grns/${slack}/invoice-data`)
    if (response?.data?.success) {
      return { success: true, data: response.data.data }
    }
    return { success: false, message: response?.data?.message }
  } catch (error) {
    return { success: false, message: error?.response?.data?.message }
  }
}

export const getGrnAttachmentApi = async (slack) => {
  try {
    const response = await get(`${process.env.EXTENDED_URL}procurement/grns/file-download/${slack}`)
    return response?.data || { success: false }
  } catch (error) {
    return { success: false }
  }
}
